var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "yxt-radio-group",
        {
          attrs: { disabled: _vm.disabled },
          model: {
            value: _vm.permissionType,
            callback: function ($$v) {
              _vm.permissionType = $$v
            },
            expression: "permissionType",
          },
        },
        [
          _c("yxt-radio", { attrs: { label: 0 } }, [
            _vm._v(
              _vm._s(
                _vm.$t("pc_biz_kng_lbl_authwithcatalog" /** 跟随分类浏览权限 */)
              )
            ),
          ]),
          _c(
            "div",
            { staticClass: "yxtbiz-flex-center mt6" },
            [
              _c("yxt-radio", { staticClass: "mr10", attrs: { label: 1 } }, [
                _vm._v(
                  _vm._s(
                    _vm.$t(
                      "pc_kng_upload_lbl_browse_allow" /** 单独设置允许浏览 */
                    )
                  )
                ),
              ]),
              _c(
                "yxt-tooltip",
                {
                  attrs: {
                    "max-width": "400",
                    effect: "dark",
                    placement: "bottom",
                    content: _vm.$t(
                      "pc_kng_upload_lbl_browse_allowtip" /*设置后即使无目录浏览权限也支持浏览*/
                    ),
                  },
                },
                [
                  _c("yxt-svg", {
                    staticClass: "hand v-mid color-gray-6",
                    attrs: {
                      width: "16px",
                      height: "16px",
                      "icon-class": "icons/question-cirlce-o",
                    },
                  }),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _vm.permissionType === 1
        ? _c("auth-selector", {
            staticClass: "mt10 ml24",
            attrs: {
              permissions: _vm.permissions,
              dataPermissionCode: _vm.isCourse
                ? "kcgl_Course_authority_selection_scope"
                : "kjgl_Courseware_browsing_permission_selection",
              disabled: _vm.disabled,
            },
            on: { update: _vm.update },
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }